import { createPersistedState } from "~/utils/persistedState";

interface SearchUiState {
  gridView: boolean | null;
  sortBy: string;
  filterSidebarOpen: boolean;
  sortSidebarOpen: boolean;
}

interface DashboardListUiState {
  gridView: boolean;
  filter: string;
  page: number;
  offset: number;
}

interface InboxUiState {
  showMessagesList: boolean;
}

interface UiState {
  search: SearchUiState;
  dashboardItems: DashboardListUiState;
  dashboardSavedItems: DashboardListUiState;
  dashboardOffers: DashboardListUiState;
  inbox: InboxUiState;
}

const state = (): UiState => ({
  search: {
    gridView: null,
    sortBy: '',
    filterSidebarOpen: false,
    sortSidebarOpen: false
  },
  dashboardItems: {
    gridView: false,
    filter: '',
    page: 1,
    offset: 0
  },
  dashboardSavedItems: {
    gridView: false,
    filter: '',
    page: 1,
    offset: 0
  },
  dashboardOffers: {
    gridView: false,
    filter: '',
    page: 1,
    offset: 0
  },
  inbox: {
    showMessagesList: true
  }
});

export const useUiStateStore = defineStore("uiState", {
  state,
  persist: createPersistedState({
    key: 'topauto:ui',
    version: 2,
    paths: [
      'search.gridView',
      'search.sortBy',
      'dashboardItems',
      'dashboardSavedItems',
      'dashboardOffers',
      'inbox'
    ]
  })
});
